// KPI-W2 (2026-05-25) — 재고 KPI 대시보드 패널
// API: GET /inventory/kpi, /inventory/longstay

import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts';

var STATUS_COLOR = {
  '등록완료': '#3b82f6', '말소신청': '#f59e0b', '말소완료': '#10b981',
  '면장신청': '#8b5cf6', '면장완료': '#06b6d4', '선적대기': '#ec4899', '선적완료': '#94a3b8'
};

function fmtKrwMan(won) {
  if (won == null) return '-';
  return '₩' + Math.round(won / 10000).toLocaleString() + '만';
}

function KpiCard(props) {
  return (
    <div style={{ flex: 1, background: '#fff', border: '1px solid #e2e8f0', borderRadius: 10, padding: '14px 16px', minWidth: 120 }}>
      <div style={{ fontSize: 12, color: '#64748b' }}>{props.label}</div>
      <div style={{ fontSize: 22, fontWeight: 800, color: props.color || '#1B3A5C', marginTop: 4 }}>{props.value}</div>
      {props.sub && <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>{props.sub}</div>}
    </div>
  );
}

function InventoryKpiPanel() {
  var [kpi, setKpi] = useState(null);
  var [longstay, setLongstay] = useState([]);

  useEffect(function() {
    authFetch(API + '/inventory/kpi').then(function(r) { return r.json(); }).then(function(d) { if (d && d.success) setKpi(d.data); }).catch(function() {});
    authFetch(API + '/inventory/longstay').then(function(r) { return r.json(); }).then(function(d) { if (d && d.success) setLongstay(d.data || []); }).catch(function() {});
  }, []);

  if (!kpi) return null;

  var chartData = (kpi.byStatus || []).map(function(s) { return { name: s.status, count: s.count }; });

  return (
    <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 12, padding: 18, marginBottom: 16 }}>
      <div style={{ fontSize: 14, fontWeight: 800, color: '#0f172a', marginBottom: 12 }}>📦 재고 현황</div>

      {/* KPI 카드 */}
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 16 }}>
        <KpiCard label="총 재고" value={kpi.totalCount + '대'} />
        <KpiCard label="재고 금액" value={fmtKrwMan(kpi.totalBuyKrw)} />
        <KpiCard label="평균 재고일수" value={kpi.avgInventoryDays + '일'} />
        <KpiCard label={'장기재고 (' + kpi.longstayDays + '일+)'} value={kpi.longstayCount + '대'} color={kpi.longstayCount > 0 ? '#dc2626' : '#1B3A5C'} />
        <KpiCard label="회전율 (30일)" value={kpi.turnover} sub={'선적 ' + kpi.shipped30d + '대'} />
      </div>

      {/* 단계별 분포 차트 */}
      {chartData.length > 0 && (
        <div style={{ background: '#fff', borderRadius: 10, padding: 12, marginBottom: 16 }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: '#64748b', marginBottom: 8 }}>단계별 분포</div>
          <ResponsiveContainer width="100%" height={180}>
            <BarChart data={chartData}>
              <XAxis dataKey="name" tick={{ fontSize: 11 }} />
              <YAxis allowDecimals={false} tick={{ fontSize: 11 }} />
              <Tooltip />
              <Bar dataKey="count" radius={[4, 4, 0, 0]}>
                {chartData.map(function(d, i) { return <Cell key={i} fill={STATUS_COLOR[d.name] || '#3b82f6'} />; })}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}

      {/* 장기재고 리스트 */}
      {longstay.length > 0 && (
        <div style={{ background: '#fff', borderRadius: 10, padding: 12 }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: '#dc2626', marginBottom: 8 }}>⚠️ 장기재고 ({longstay.length}대)</div>
          {longstay.slice(0, 8).map(function(c) {
            return (
              <div key={c.id} style={{ display: 'flex', justifyContent: 'space-between', padding: '5px 0', borderTop: '1px solid #f8fafc', fontSize: 13 }}>
                <span><b>{c.carNo}</b> {c.carType} <span style={{ color: '#94a3b8' }}>· {c.status}</span></span>
                <span style={{ fontWeight: 700, color: '#dc2626' }}>{c.inventoryDays}일</span>
              </div>
            );
          })}
          {longstay.length > 8 && <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 6 }}>외 {longstay.length - 8}대</div>}
        </div>
      )}
    </div>
  );
}

export default InventoryKpiPanel;
